import axios from 'axios'
import store from '@store'
import * as types from '@store/types'
import * as CComponents from '@components/CComponents'
import scroll from 'smoothscroll-polyfill'
import Can from '@/helpers/can'
import Portal from 'portal-vue'
import dayjs from 'dayjs'

window.__forceSmoothScrollPolyfill__ = true
scroll.polyfill()

function checkError (errors, status) {
  const { token: hasToken, expiresAt } = store.getters[types.AUTH]
  const isLogged = (Date.now() < expiresAt) && hasToken

  const messages = ['token_not_provided', 'Unauthorized', 'token_invalid', 'Token not provided', 'User not found', 'user_not_found']

  const isArray = Array.isArray(errors) && errors.some(({ message }) => messages.includes(message))
  const isString = typeof errors === 'string' && messages.includes(errors)
  const isStatus = status && (status === 401 || status === 403)

  if (isLogged && (isArray || isString || isStatus)) store.dispatch(types.AUTH_LOGOUT)
}

export default (Vue) => {
  /**
   * Define a `baseURL` e outras configurações padrão.
   */
  axios.interceptors.request.use(({ baseURL, headers, ...config }) => {
    const { token } = store.getters[types.AUTH]
    return {
      ...config,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : null),
        ...headers
      },
      baseURL: baseURL || process.env.RESTFUL_API
    }
  })

  /**
   * Faz logout ou receber a responsta de Token Inválido.
   */
  axios.interceptors.response.use((response) => {
    checkError(response.data.errors || [])
    return response
  },
  error => {
    let e
    let errors
    let status

    if (error.response) {
      status = error.response.status ? error.response.status : {}
      e = error.response.data.error ? error.response.data.error : []
      errors = error.response.data.errors ? error.response.data.errors : []
    }

    checkError((e || errors || []), status)

    return Promise.reject(error)
  }
  )

  Vue.mixin({
    filters: {
      dateFormat (value) {
        if (!value) return ''

        const creationDate = value * 1000
        const dateDiff = dayjs().diff(creationDate, 'days')

        if (dateDiff === 0) { return `Hoje às ${dayjs(creationDate).format('HH:mm')}` } else if (dateDiff === 1) { return `Ontem às ${dayjs(creationDate).format('HH:mm')}` } else { return `Há ${dateDiff} dias` }
      }
    },
    data () {
      return {
        matchMedia: window.matchMedia('(min-width: 769px)'),
        matchMediaLg: window.matchMedia('(min-width: 769px) and (max-width: 1354px)'),
        isDesktop: false,
        isLgScreen: false
      }
    },
    beforeDestroy () {
      this.matchMedia.removeListener(this.setBreakpoint)
      this.matchMediaLg.removeListener(this.setBreakpointLg)
    },
    mounted () {
      this.matchMedia.addListener(this.setBreakpoint)
      this.matchMedia.addListener(this.setBreakpointLg)
      this.setBreakpoint()
      this.setBreakpointLg()
    },
    methods: {
      setBreakpoint () {
        this.isDesktop = this.matchMedia && this.matchMedia.matches
      },
      setBreakpointLg () {
        this.isLgScreen = this.matchMediaLg && this.matchMediaLg.matches
      }
    }
  })

  Vue.use(Can, store, types)
  Vue.use(Portal)
  Vue.use((Vue) => {
    Object.keys(CComponents).forEach((name) => {
      const comp = CComponents[name]
      if (comp && comp.name) {
        Vue.component(comp.name || name, comp)
      } else if (comp) {
        Vue.component(name, comp)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/plugins.js